import isNil from 'lodash-es/isNil';

import { FieldsEnum, FormsEnum, SectionsEnum } from 'app/shared/enums';
import {
  getCarData,
  getFormValue,
  setSectionVisibilityHelper,
} from 'app/services/businessFunctionHelpers';
import { isValidCarRegistrationNumber } from 'app/validators/validateCarRegistrationNumber';
import { historyQuestionsVisibilityBasedOnPersonalData } from 'app/services/env.service';

interface HistoryVisibilityBasedOnPersonalDataConfig {
  insuranceHistorySection: SectionsEnum;
  formName: FormsEnum;
}

export function setHistoryVisibilityBasedOnPersonalData({
  insuranceHistorySection,
  formName,
}: HistoryVisibilityBasedOnPersonalDataConfig) {
  if (!historyQuestionsVisibilityBasedOnPersonalData) return;

  const showMorePersonalData = getFormValue(FieldsEnum.PersonalDataPath);
  const { registrationNumber } = getCarData();

  const isRegistrationNumberValid =
    registrationNumber !== '' &&
    !isNil(registrationNumber) &&
    (isValidCarRegistrationNumber(registrationNumber) ||
      registrationNumber.includes('***'));

  setSectionVisibilityHelper({
    key: insuranceHistorySection,
    formName: formName,
    visible: !isRegistrationNumberValid || !showMorePersonalData,
  });
}
